import { render, staticRenderFns } from "./workspace-knowledge.vue?vue&type=template&id=408549b8&scoped=true"
import script from "./workspace-knowledge.vue?vue&type=script&lang=js"
export * from "./workspace-knowledge.vue?vue&type=script&lang=js"
import style0 from "./workspace-knowledge.vue?vue&type=style&index=0&id=408549b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408549b8",
  null
  
)

export default component.exports